import { ErrorMessage } from "@hookform/error-message";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { Maybe } from "../../utils/types/maybe.ts";
import ErrorLabel from "./errorLabel.tsx";

interface EntityWithId {
  id: string;
}

type Props<T> = {
  name: string;
  label: string;
  data: T[];
  formatOption: (option: T) => string;
  onChange: (value: Maybe<T>) => void;
};

export default function EntitySelect<T extends EntityWithId>({
  name,
  label,
  data,
  formatOption,
  onChange,
}: Props<T>) {
  return (
    <div className="sm:col-span-4">
      <label
        htmlFor={name}
        className="block text-sm font-medium leading-6 text-gray-900"
      >
        {label}
      </label>
      <div className="mt-1 flex gap-2 border-0 bg-transparent py-1.5">
        <Controller
          name={name}
          render={({ field }) => (
            <Select
              className="!text-gray-900 sm:text-sm sm:leading-6 flex-grow"
              classNames={{
                control: (state) =>
                  state.isFocused
                    ? "!border-sky-600 !shadow-sm"
                    : "border-grey-300",
                option: () => "!text-gray-900",
              }}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary: "#bae6fd",
                },
              })}
              options={data.map((value) => ({
                label: formatOption(value),
                value,
              }))}
              isClearable={true}
              isSearchable={true}
              {...field}
              onChange={(e) => {
                field.onChange(e?.value?.id);
                onChange(e?.value as Maybe<T>);
              }}
              value={
                data.find((entity) => entity.id === field.value) != null
                  ? {
                      label: formatOption(
                        data.find((entity) => entity.id === field.value)!,
                      ),
                      value: data.find((entity) => entity.id === field.value),
                    }
                  : null
              }
            />
          )}
        />
        <div className="flex-none p-1.5">
          <div className="w-5" />
        </div>
      </div>
      <ErrorMessage
        name={name}
        render={({ message }) => <ErrorLabel message={message} />}
      />
    </div>
  );
}
